(function () {
    'use strict';
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
    const sitePath = window.SiteInfo?.Site?.Path ?? '';
    const siteBaseUrl = window.SiteInfo?.Site?.BaseUrl ?? '';
    const filterForm = document.getElementById("advancedSearchFilterForm");
    const baseUrl = (siteBaseUrl || window.location.origin + sitePath);
    const SEARCH_URL = `${baseUrl}/search/article-search`;
    const EDITION_URL = `${baseUrl}/search/article-edition`;
    const tokenInput = document.querySelector('input[name="__RequestVerificationToken"]');
    const csrfToken = tokenInput?.value;
    let currentPage = 1;
    let totalCount = 0;
    let selectedAuthors = [];

    function formatPublishDate(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        return `(Published ${date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        })})`;
    }

    function formatDate(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date)) return "";
        return date.toLocaleString("en-US", {
            month: "short",
            year: "numeric"
        });
    }

    // LOAD EDITIONS
    async function loadEditions() {
        try {

            const response = await fetch(EDITION_URL, {
                method: "GET",
                headers: {
                    "RequestVerificationToken": csrfToken
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const editions = await response.json();

            const selects = document.querySelectorAll('#edition');

            selects.forEach(select => {

                while (select.options.length > 1) {
                    select.remove(1);
                }

                editions.forEach(edition => {
                    const option = document.createElement('option');
                    option.value = edition;
                    option.textContent = edition;
                    select.appendChild(option);
                });
            });

        } catch (error) {
            console.error('Failed to load editions:', error);
        }
    }

    function showLoader() {
        document.getElementById("searchLoader").style.display = "block";
        document.getElementById("searchResults").innerHTML = "";
        const pagination = document.getElementById("pagination");
        if (pagination) pagination.style.pointerEvents = "none";
    }

    function hideLoader() {
        document.getElementById("searchLoader").style.display = "none";
        const pagination = document.getElementById("pagination");
        if (pagination) pagination.style.pointerEvents = "auto";
    }


    // PAYLOAD BUILDERS

    function buildPayload() {

        const getValue = (selector1, selector2) =>
            document.querySelector(selector1)?.value ||
            document.querySelector(selector2)?.value ||
            "";

        const size =
            document.querySelector("#advancedSearchResultsContainer #viewBy")?.value ||
            document.querySelector("#advancedSearchMainForm #viewBy")?.value || 10;

        const sort =
            document.querySelector("#advancedSearchResultsContainer #sortBy")?.value ||
            document.querySelector('input[name="sorting"]:checked')?.value ||
            "Relevance";

        const author = getValue("#advancedSearchFilterForm #author", "#advancedSearchMainForm #author");
        const title = getValue("#advancedSearchFilterForm #title", "#advancedSearchMainForm #title");
        const words = getValue("#advancedSearchFilterForm #words", "#advancedSearchMainForm #words");
        const keywordsInput = getValue("#advancedSearchFilterForm #keywords", "#advancedSearchMainForm #keywords");

        const fromDate = getValue("#advancedSearchFilterForm #fromDate", "#advancedSearchMainForm #fromDate");
        const toDate = getValue("#advancedSearchFilterForm #toDate", "#advancedSearchMainForm #toDate");

        const category = getValue("#advancedSearchFilterForm #categories", "#advancedSearchMainForm #categories");
        const articleType = getValue("#advancedSearchFilterForm #articleBy", "#advancedSearchMainForm #articleBy");
        const edition = getValue("#advancedSearchFilterForm #edition", "#advancedSearchMainForm #edition");

        const keywords = keywordsInput
            .split(/[\s,]+/)
            .map(k => k.trim())
            .filter(k => k.length > 0);

        const authors = selectedAuthors.length
            ? selectedAuthors
            : author
                .split(",")
                .map(a => a.trim())
                .filter(a => a);

        return {
            From: (currentPage - 1) * parseInt(size),
            Size: parseInt(size),
            ContentType: "Article",
            Word: words,
            Keywords: keywords,
            Title: title,
            SortBy: sort,
            FromDate: fromDate || null,
            ToDate: toDate || null,
            Categories: category ? [category] : [],
            Authors: authors,
            ArticleType: articleType ? [articleType] : [],
            Edition: edition || null
        };
    }

    function getPayloadFromURL() {
        const params = new URLSearchParams(window.location.search);
        currentPage = parseInt(params.get("page")) || 1;
        return {
            From: (currentPage - 1) * (parseInt(params.get("size")) || 10),
            Size: parseInt(params.get("size")) || 10,
            ContentType: "Article",
            Title: params.get("title") || "",
            Keywords: params.get("keywords")?.split(",") || [],
            Authors: params.get("author") ? [params.get("author")] : [],
            Categories: params.get("category") ? [params.get("category")] : [],
            FromDate: params.get("from"),
            ToDate: params.get("to"),
            SortBy: params.get("sort") || "Relevance",
            ArticleType: params.get("articleType") ? [params.get("articleType")] : [],
            Edition: params.get("edition") || null
        };
    }


    // URL HANDLING

    function updateURL(payload) {
        const params = new URLSearchParams();

        if (payload.Title) params.set("title", payload.Title);
        if (payload.Authors?.length) params.set("author", payload.Authors.join(","));
        if (payload.Keywords?.length) params.set("keywords", payload.Keywords.join(","));
        if (payload.Categories?.length) params.set("category", payload.Categories.join(","));
        if (payload.FromDate) params.set("from", payload.FromDate);
        if (payload.ToDate) params.set("to", payload.ToDate);
        if (payload.SortBy) params.set("sort", payload.SortBy);
        if (payload.Size) params.set("size", payload.Size);
        if (payload.ArticleType?.length) params.set("articleType", payload.ArticleType[0]);
        if (payload.Edition) params.set("edition", payload.Edition);
        params.set("page", currentPage);

        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, "", newUrl);
    }


    // SUMMARY

    function updateSearchSummary(payload) {
        const el = document.getElementById("searchSummary");
        if (!el) return;

        const template = el.dataset.template;

        //  AUTHOR
        let authorPart = "";
        if (payload.Authors?.length) {
            authorPart = `<strong>${payload.Authors.join(", ")}</strong> in author`;
        }

        //  TITLE + WORD TYPE
        let titlePart = "";
        if (payload.Title) {
            const wordType = payload.Word ? ` (${getWordLabel(payload.Word)})` : "";
            titlePart = `${authorPart ? " and " : ""}<strong>${payload.Title}</strong>${wordType} in title`;
        }

        //  FULL TEXT
        let fullTextPart = "";
        if (payload.Title || payload.Keywords?.length) {
            fullTextPart = `${(authorPart || titlePart) ? " and " : ""}in full text`;
        }

        //  DATES
        let datePart = "";
        const dateText = getDatePart(payload);
        if (dateText) {
            datePart = `, ${dateText}`;
        }

        //  REPLACE TEMPLATE
        const result = template
            .replace("{{author}}", authorPart)
            .replace("{{title}}", titlePart)
            .replace("{{fulltext}}", fullTextPart)
            .replace("{{dates}}", datePart);

        //  FALLBACK
        el.innerHTML = (authorPart || titlePart || fullTextPart)
            ? result
            : "<p>Showing all results</p>";
    }

    function updateResultCountSummary(payload) {
        const el = document.getElementById("resultCountSummary");
        const summaryEl = document.getElementById("searchSummary");

        if (!el || !summaryEl) return;

        if (!totalCount) {
            el.innerHTML = "";
            return;
        }

        const size = payload.Size;
        const start = (currentPage - 1) * size + 1;
        const end = Math.min(currentPage * size, totalCount);

        const filterHTML = summaryEl.innerHTML
            .replace(/^<p>|<\/p>$/g, "")
            .replace(/^Searching content for\s*/i, "")
            .trim();

        const isAllResults = /Showing all results/i.test(filterHTML);

        el.innerHTML = `
        <p>
            Showing results 
            ${start.toLocaleString()} 
            to 
            ${end.toLocaleString()} 
            of 
            ${totalCount.toLocaleString()}
            ${(!isAllResults && filterHTML) ? ` for ${filterHTML}` : ""}
        </p>
        `;
    }

    function getWordLabel(type) {
        return {
            phrase: "as phrase",
            all: "all words",
            any: "any words"
        }[type] || "";
    }

    function getFieldPart(payload, word) {
        let fields = [];
        if (payload.Keywords?.length) fields.push("keywords");
        if (!word || !fields.length) return "";
        return `${word} is ${fields.join(" or ")}`;
    }

    function getDatePart(payload) {
        if (!payload.FromDate && !payload.ToDate) return "";
        const from = payload.FromDate ? formatDate(payload.FromDate) : "";
        const to = payload.ToDate ? formatDate(payload.ToDate) : "";
        if (from && to) return `from ${from} to ${to}`;
        if (from) return `from ${from}`;
        return `up to ${to}`;
    }

    // SYNC VALUES
    function syncFilterFormFromMain() {

        const selectedRadio = document.querySelector('input[name="sorting"]:checked');
        const mainView = document.querySelector("#advancedSearchMainForm #viewBy");
        const mainEdition = document.querySelector("#advancedSearchMainForm #edition");

        const sortValue = selectedRadio ? selectedRadio.value : "Relevance";
        const viewValue = mainView ? mainView.value : "10";
        const editionValue = mainEdition ? mainEdition.value : "";

        const sortDropdown = document.querySelector("#advancedSearchFilterForm #sortBy");
        const viewDropdown = document.querySelector("#advancedSearchFilterForm #viewBy");
        const editionDropdown = document.querySelector("#advancedSearchFilterForm #edition");

        if (sortDropdown) sortDropdown.value = sortValue;
        if (viewDropdown) viewDropdown.value = viewValue;
        if (editionDropdown) editionDropdown.value = editionValue;
    }


    function getEditionRange(edition) {
        if (!edition) return null;

        const [season, yearStr] = edition.split(" ");
        const year = parseInt(yearStr);

        function endOfDay(date) {
            date.setHours(23, 59, 59, 999);
            return date;
        }

        switch (season.toLowerCase()) {
            case "spring":
                return {
                    start: new Date(year, 2, 1),
                    end: endOfDay(new Date(year, 5, 0))
                };

            case "summer":
                return {
                    start: new Date(year, 5, 1),
                    end: endOfDay(new Date(year, 8, 0))
                };

            case "autumn":
                return {
                    start: new Date(year, 8, 1),
                    end: endOfDay(new Date(year, 11, 0))
                };

            case "winter":
                return {
                    start: new Date(year, 11, 1),
                    end: endOfDay(new Date(year + 1, 2, 0))
                };

            default:
                return null;
        }
    }

    function validateEditionDates(payload) {

        const errorEl = document.getElementById("editionDateError");

        // Clear previous error
        if (errorEl) {
            errorEl.textContent = "";
        }

        // Nothing to validate
        if (!payload.Edition || (!payload.FromDate && !payload.ToDate)) {
            return true;
        }

        const range = getEditionRange(payload.Edition);

        if (!range) {
            return true;
        }

        const fromDate = payload.FromDate ? new Date(payload.FromDate) : null;
        const toDate = payload.ToDate ? new Date(payload.ToDate) : null;

        const isInvalid =
            (fromDate && (fromDate < range.start || fromDate > range.end)) ||
            (toDate && (toDate < range.start || toDate > range.end));

        if (isInvalid) {
            if (errorEl) {
                errorEl.textContent = `Selected dates must be within ${payload.Edition}.`;
            }

            return false;
        }

        return true;
    }


    // API CALLS

    async function searchArticles() {
        showLoader();

        const payload = buildPayload();

        if (!validateEditionDates(payload)) {
            hideLoader();
            return;
        }

        updateURL(payload);
        updateSearchSummary(payload);

        try {
            const response = await fetch(SEARCH_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "RequestVerificationToken": csrfToken
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            totalCount = result.totalCount || 0;
            updateResultCountSummary(payload);
            renderResults(result.results);
            renderPagination();

        } catch (error) {
            console.error(error);
        } finally {
            hideLoader();
        }
    }

    async function searchArticlesWithPayload(payload) {
        showLoader();

        if (!validateEditionDates(payload)) {
            hideLoader();
            return;
        }

        updateSearchSummary(payload);

        try {
            const response = await fetch(SEARCH_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "RequestVerificationToken": csrfToken
                },
                body: JSON.stringify(payload)
            });

            console.log("Search Status:", response.status);

            const result = await response.json();

            totalCount = result.totalCount || 0;
            updateResultCountSummary(payload);
            renderResults(result.results);
            renderPagination();

        } catch (error) {
            console.error(error);
        } finally {
            hideLoader();
        }
    }


    // RENDER

    function bindGoBackButton() {
        const btn = document.querySelector(".advanced-search__button--back");

        if (!btn) return;

        btn.addEventListener("click", function () {

            document.getElementById("advancedSearchContainer").style.display = "block";
            document.getElementById("advancedSearchResultsContainer").style.display = "none";

            document.getElementById("searchResults").innerHTML = "";
            document.getElementById("searchSummary").innerHTML = "";
            document.getElementById("resultCountSummary").innerHTML = "";

            if (filterForm) filterForm.reset();

            window.history.pushState({}, "", window.location.pathname);

            document.querySelectorAll(".advance-search__paragraph")
                .forEach(item => item.style.display = "");
        });
    }

    function renderResults(data) {
        const container = document.getElementById("searchResults");

        if (!data || data.length === 0) {
            container.innerHTML = `
        <div class="advanced-search__result--empty">
            <p>
               Your search yielded no results.
            </p>
            <button class="advanced-search__button--back">
                ← Go back to filters
            </button>
        </div>
    `;
            bindGoBackButton();

            if (filterForm) {
                filterForm.style.display = "none";
            }

            return;
        }

        if (filterForm) {
            filterForm.style.display = "block";
        }

        container.innerHTML = data.map(item => `

    <article class="advanced-search__result">

    ${(Array.isArray(item.primaryCategory) && item.primaryCategory.length) ||
                (Array.isArray(item.author) && item.author.length)
                ? `
        <div class="advanced-search__result-meta">
            
            ${(Array.isArray(item.primaryCategory) && item.primaryCategory.length && item.primaryCategoryDisplay?.[0]?.toLowerCase() === "true")
                    ? `
                <span class="advanced-search__result-category">
                    ${item.primaryCategory.map((cat, i) => `
                        <a href="${item.primaryCategoryAutoroute[i]}" class="result-link">
                               ${cat?.split('/')[0].split('(')[0].trim()}
                        </a>
                    `).join(", ")}
                </span>
                `
                    : ""
                }

            ${(Array.isArray(item.primaryCategory) && item.primaryCategory.length) && item.primaryCategoryDisplay?.[0]?.toLowerCase() === "true" &&
                    (Array.isArray(item.author) && item.author.length)
                    ? `<span class="mx-2">|</span>`
                    : ""
                }

            ${(Array.isArray(item.author) && item.author.length)
                    ? `
                <span class="advanced-search__result-author">
                    <em>${item.author.map((author, i) => {
                        const isInactive =
                            item.authorInactive?.[i]?.toLowerCase() === "true";

                        return isInactive
                            ? `<span>${author}</span>`
                            : `
            <a href="${item.authorAutoroute?.[i] || '#'}" class="result-link">
                ${author}
            </a>
        `;
                    }).join(", ")}</em>
                </span>
                `
                    : ""
                }

        </div>
        `
                : ""
            }

    <h3 class="advanced-search__result-title">
        <a href="${item.link}" class="result-link">
            ${item.title}
        </a>
    </h3>

    ${item.summary
                ? `<p class="advanced-search__result-description">${item.summary}</p>`
                : ""
            }

    ${item.publishDate
                ? `<p class="advanced-search__result-date">${formatPublishDate(item.publishDate)}</p>`
                : ""
            }

</article>
`).join("");
    }

    function renderPagination() {
        const container = document.getElementById("pagination");
        if (!container) return;

        const pageSize =
            document.querySelector("#advancedSearchResultsContainer #viewBy")?.value || 10;

        const totalPages = Math.ceil(totalCount / pageSize);

        if (totalPages <= 1) {
            container.innerHTML = "";
            return;
        }

        let html = "";

        if (currentPage > 1) {
            html += `<button class="pagination__button pagination__button--nav" data-page="1"><i class="fa-solid fa-angles-left"></i></button>`;
        }

        if (currentPage > 1) {
            html += `<button class="pagination__button pagination__button--nav" data-page="${currentPage - 1}"><i class="fa-solid fa-angle-left"></i></button>`;
        }

        let start;
        let end;

        if (totalPages <= 4) {
            start = 1;
            end = totalPages;
        } else if (currentPage <= 2) {
            start = 1;
            end = 4;
        } else if (currentPage >= totalPages - 1) {
            start = totalPages - 3;
            end = totalPages;
        } else {
            start = currentPage - 1;
            end = currentPage + 2;
        }

        if (start > 1) {
            html += `<span class="pagination__ellipsis">...</span>`;
        }

        for (let i = start; i <= end; i++) {
            html += `
            <button class="pagination__button pagination__button--number ${i === currentPage ? "active" : ""}" data-page="${i}">
                ${i}
            </button>
        `;
        }

        if (end < totalPages) {
            html += `<span class="pagination__ellipsis">...</span>`;
        }

        if (currentPage < totalPages) {
            html += `<button class="pagination__button pagination__button--nav" data-page="${currentPage + 1}"><i class="fa-solid fa-angle-right"></i></button>`;
        }

        if (currentPage < totalPages) {
            html += `<button class="pagination__button pagination__button--nav" data-page="${totalPages}"><i class="fa-solid fa-angles-right"></i></button>`;
        }

        container.innerHTML = html;

        bindPaginationEvents();
    }

    function bindPaginationEvents() {
        document.querySelectorAll(".pagination__button").forEach(btn => {
            btn.addEventListener("click", function () {
                currentPage = parseInt(this.dataset.page);
                searchArticles();
                window.scrollTo({ top: 0, behavior: "smooth" });
            });
        });
    }


    // INIT

    function init() {
        loadEditions();

        const mainForm = document.getElementById("advancedSearchMainForm");
        const authorInput = document.getElementById("author");
        const addAuthorBtn = document.querySelector("#advancedSearchMainForm .advanced-search__button--author");
        let errorEl = null;
        const fromDateEl = document.getElementById("fromDate");
        const toDateEl = document.getElementById("toDate");

        if (fromDateEl && toDateEl) {
            fromDateEl.addEventListener("change", function () {
                toDateEl.min = this.value;
            });

            toDateEl.addEventListener("change", function () {
                fromDateEl.max = this.value;
            });
        }

        function getErrorEl() {
            if (!errorEl) {
                errorEl = document.createElement("span");
                errorEl.className = "advanced-search__error advanced-search__error--author";
                Object.assign(errorEl.style, {
                    color: "red",
                    fontSize: "14px",
                    marginTop: "4px",
                    display: "block"
                });

                const container = document.querySelector(".advanced-search__authors");

                if (container) {
                    container.parentNode.insertBefore(errorEl, container);
                }
            }
            return errorEl;
        }

        function isDuplicateAuthor(value) {
            const val = value.toLowerCase();
            return selectedAuthors.some(a => a.toLowerCase() === val);
        }

        if (authorInput && addAuthorBtn) {
            addAuthorBtn.addEventListener("click", () => {
                const value = authorInput.value.trim();
                if (!value) return;

                const err = getErrorEl();

                if (isDuplicateAuthor(value)) {
                    err.textContent = "This author is already added. Please enter a different one";
                    return;
                }

                err.textContent = "";
                selectedAuthors.push(value);
                authorInput.value = "";

                renderAuthorChips();
            });

            // CLEAR ERROR ON INPUT
            authorInput.addEventListener("input", () => {
                if (errorEl) errorEl.textContent = "";
            });
        }
        // MAIN FORM
        if (mainForm) {
            mainForm.addEventListener("submit", function (e) {
                e.preventDefault();

                const payload = buildPayload();

                if (!validateEditionDates(payload)) {
                    return;
                }

                window.scrollTo({ top: 0, behavior: "smooth" });

                document.querySelectorAll(".advance-search__paragraph")
                    .forEach(item => item.style.display = "none");

                document.getElementById("advancedSearchContainer").style.display = "none";
                document.getElementById("advancedSearchResultsContainer").style.display = "block";

                syncFilterFormFromMain();
                currentPage = 1;
                searchArticles();
            });
        }

        if (filterForm) {
            filterForm.addEventListener("submit", function (e) {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
                currentPage = 1;
                searchArticles();
            });
        }

        if (window.location.search) {
            document.querySelectorAll(".advance-search__paragraph").forEach(item => item.style.display = "none");
            document.getElementById("advancedSearchContainer").style.display = "none";
            document.getElementById("advancedSearchResultsContainer").style.display = "block";
            syncFilterFormFromMain();
            const payload = getPayloadFromURL();
            searchArticlesWithPayload(payload);
        }

        window.addEventListener("popstate", function () {

            if (!window.location.search) {

                document.getElementById("advancedSearchContainer").style.display = "block";
                document.getElementById("advancedSearchResultsContainer").style.display = "none";

                document.getElementById("searchResults").innerHTML = "";
                document.getElementById("searchSummary").innerHTML = "";

                if (filterForm) filterForm.reset();

                document.querySelectorAll(".advance-search__paragraph")
                    .forEach(item => item.style.display = "");

                return;
            }

            const payload = getPayloadFromURL();

            document.getElementById("advancedSearchContainer").style.display = "none";
            document.getElementById("advancedSearchResultsContainer").style.display = "block";

            document.querySelectorAll(".advance-search__paragraph")
                .forEach(item => item.style.display = "none");

            restoreForm(payload);
            searchArticlesWithPayload(payload);
        });
    }

    function renderAuthorChips() {
        const container = document.querySelector(".advanced-search__authors");
        if (!container) return;

        if (!selectedAuthors.length) {
            container.innerHTML = "";
            return;
        }

        container.innerHTML = selectedAuthors.map((a, i) => `
        <span class="advanced-search__author">
            ${a}
            <button type="button" data-index="${i}"><i class="fa-solid fa-x"></i></button>
        </span>
    `).join("");

        container.querySelectorAll("button").forEach(btn => {
            btn.addEventListener("click", function () {
                selectedAuthors.splice(this.dataset.index, 1);
                renderAuthorChips();
            });
        });
    }

    document.readyState === "loading"
        ? document.addEventListener("DOMContentLoaded", init)
        : init();

})();
